<template>
  <div class="volume">
    <template v-if="loadingState">
      <div class="spinner">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 200 117" style="enable-background:new 0 0 200 117;" xml:space="preserve">
            <g id="triangle8">
                <path class="st0" d="M153,60.4l-22,10.9l22-31.4V60.4z"/>
            </g>
            <g id="triangle7">
                <path class="st1" d="M131,71.2l-24.4-25l46.4-6.5L131,71.2z"/>
            </g>
            <g id="triangle6">
                <path class="st2" d="M131,71.2L111.1,90l-4.5-43.8L131,71.2z"/>
            </g>
            <g id="triangle5">
                <path class="st0" d="M109.6,76.1l-2.2-21.5l0.3,21.4L109.6,76.1z"/>
            </g>
            <g id="triangle4">
                <path class="st1" d="M106.6,46.2l0.8,8.3l0.3,21.4l-23.2-1.5L106.6,46.2z"/>
            </g>
            <g id="triangle3">
                <path class="st3" d="M84.5,74.5L59.6,51l47-4.7L84.5,74.5z"/>
            </g>
            <g id="triangle2">
                <polygon class="st0" points="50.5,52 37.9,30.5 69.7,60.4"/>
            </g>
            <g id="triangle1">
                <path class="st2" d="M50.5,52l-12,18.3L59.6,56L50.5,52z"/>
            </g>
        </svg>
      </div>
    </template>

    <template v-if="!loadingState">
      <div class="content-headline">
        <div class="content-headline__wrapper">
          <h1>{{locale.volumes.title}}</h1>
          <div class="content-headline__control-buttons">
            <button class="button action-tooltip" v-on:click="openModal({ 'id': 'modalNewVolume'},setFormData({'name':'','size':20}))">{{locale.volumes.buttonNewVolume}}</button>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="responsive">
          <thead>
          <tr>
            <th scope="col">{{locale.volumes.size}}</th>
            <th scope="col">{{locale.volumes.server}}</th>
            <th scope="col">{{locale.volumes.action}}</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="volume in volumes">
            <tr :key="volume.id">
              <td data-label="Name">{{volume.size}} GB</td>
              <td data-label="Server">{{ getAttachedServerNameFromVolume(volume.server_id) }}</td>
              <td data-label="Action">
                <template v-if="!volume.server_id">
                  <a href="#" v-on:click="openModal({ 'id': 'modalResize', 'data': volume}), setFormData(volume)" class="action-tooltip">
                    <span class="actions-icon actions-icon--resize"></span>
                    <div class="tooltip">
                      <span class="tooltiptext">{{locale.volumes.tooltip.resize}}</span>
                    </div>
                  </a>
                  <a href="#" v-on:click="openModal({ id: 'modalAttach', data: volume}), setFormData(volume)" class="action-tooltip">
                    <span class="actions-icon actions-icon--attach-volume"></span>
                    <div class="tooltip">
                      <span class="tooltiptext">{{locale.volumes.tooltip.attach}}</span>
                    </div>
                  </a>
                  <a href="#" v-on:click="openModal({ id: 'modalDelete', data: volume}), setFormData(volume)" class="action-tooltip">
                    <span class="actions-icon actions-icon--trash"></span>
                    <div class="tooltip">
                      <span class="tooltiptext">{{locale.volumes.tooltip.delete}}</span>
                    </div>
                  </a>
                </template>
                <template v-if="volume.server_id">
                  <a href="#" v-on:click="openModal({ id: 'modalDetach', data: volume}), setFormData(volume)" class="action-tooltip">
                    <span class="actions-icon actions-icon--detach-volume"></span>
                    <div class="tooltip">
                      <span class="tooltiptext">{{locale.volumes.tooltip.detach}}</span>
                    </div>
                  </a>
                </template>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </template>
    <ModalBox id="modalResize">
      <template slot="header">
        {{locale.volumes.modal.resize.title}}
      </template>
      <template slot="body">
        <form class="form" @submit.prevent="submitModalResizes">
          <div style="height: 80px;">
            <vue-slider name="form.size" v-model="form.size"  :marks="[modalData.size, 500, 1000, 1500, 2000]" :interval="10" :min="modalData.size" :max=2000 :tooltip="'always'" :tooltip-formatter="formatter1" :tooltip-placement="'bottom'"></vue-slider>
          </div>
          <div class="modal-buttons">
            <button class="button" v-on:click="closeModal({id: 'modalResize'})" >{{locale.volumes.buttonSave}}</button>
          </div>
        </form>
      </template>
    </ModalBox>
    <ModalBox id="modalNewVolume">
      <template slot="header">
        {{locale.volumes.modal.newvolume.title}}:
      </template>
      <template slot="body">
        <form class="form" @submit.prevent="submitModalNew">
          <label>Volume Name</label>
          <div>
            <input type="text" v-model="form.name"/>
          </div>
          <div>
            <label class="radio-label">
              <input type="radio" v-model="form.type" value="ssd"/>
              SSD
            </label>
            <label class="radio-label">
              <input type="radio" v-model="form.type" value="hdd"/>
              HDD
            </label>
          </div>
          <label>{{locale.volumes.modal.newvolume.size}}</label>
          <div style="height: 80px;">
            <vue-slider name="form.size" v-model="form.size"  :marks="[modalData.size, 500, 1000, 1500, 2000]" :interval="10" :min="20" :max=2000 :tooltip="'always'" :tooltip-formatter="formatter1" :tooltip-placement="'bottom'"></vue-slider>
          </div>
          <div class="modal-buttons">
            <button class="button" v-on:click="closeModal({ 'id': 'modalNewVolume' })">{{locale.volumes.modal.newvolume.submit}}</button>
          </div>
        </form>
      </template>
    </ModalBox>
    <ModalBox id="modalDelete">
      <template slot="header">
        {{locale.volumes.modal.delete.title}}
      </template>
      <template slot="body">
        <div class="modal-buttons">
          <a href="#" class="button button--secondary" v-on:click="closeModal({id: 'modalDelete'})">{{locale.volumes.buttonCancel}}</a>
          <a href="#" class="button button--danger" v-on:click="deleteVolume(modalData.id) + closeModal({id: 'modalDelete'})">{{locale.volumes.buttonDelete}}</a>
        </div>
      </template>
    </ModalBox>
    <ModalBox id="modalAttach">
      <template slot="header">
        {{locale.volumes.modal.attach.title}}
      </template>
      <template slot="body">
        <div class="select-wrapper">
          <select class="select" v-model="form.selectedCompute" v-validate="'required|min:1'" data-vv-name="form.selectedCompute">
            <option value=""></option>
            <template v-for="compute in computes">
              <option v-bind:key="compute.id"  :value="compute.id">{{ compute.name }}</option>
            </template>
          </select>
        </div>
        <div class="modal-buttons">
          <a href="#" class="button button--secondary" v-on:click="closeModal({id: 'modalAttach'})">{{locale.volumes.buttonCancel}}</a>
          <a href="#" class="button" v-on:click="attachVolumeToServer(form.selectedCompute, modalData.id)" data-dismiss="modal">{{locale.volumes.buttonAssign}}</a>
        </div>
      </template>
    </ModalBox>
    <ModalBox id="modalDetach">
      <template slot="header">
        {{locale.volumes.modal.detach.title}}
      </template>
      <template slot="body">
        <div class="modal-buttons">
          <a href="#" class="button button--secondary" v-on:click="closeModal({id: 'modalDetach'})">{{locale.volumes.buttonCancel}}</a>
          <a href="#" class="button button--danger" v-on:click="detachVolumeFromServer(modalData.server_id,modalData.id) + closeModal({id: 'modalDetach'})">{{locale.volumes.buttonDetach}}</a>
        </div>
      </template>
    </ModalBox>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import ModalBox from '../utils/modalBox.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import errorMessages from '../utils/errorMessages.vue'

export default {
  name: 'Volumes',
  components: {
    ModalBox,
    VueSlider,
    errorMessages
  },
  data: function () {
    return {
      interval: null,
      formatter1: '{value} GB',
      form: {
        size: 20,
        name: '',
        selectedCompute: ''
      }
    }
  },
  computed: {
    ...mapState([
      'locale'
    ]),
    ...mapState({
      volumes: state => state.volumes.volumes,
      loadingState: state => state.loadingState,
      modalData: state => state.modal.modalData,
      computes: state => state.computes.computes
    })
  },
  methods: {
    ...mapActions({
      'openModal': 'modal/openModal',
      'closeModal': 'modal/closeModal',
      'deleteVolume': 'volumes/deleteVolume'
    }),
    refresh () {
      this.interval = setInterval(function () {
        this.$store.dispatch('volumes/getVolumes', 0)
      }.bind(this), 1000)
    },
    setFormData (data) {
      this.form.size = data.size
      this.form.id = data.id
      this.form.name = data.name
    },
    submitModalResizes () {
      this.$store.dispatch('volumes/resizeVolume', this.form).then(() => {
        this.$store.dispatch('volumes/getVolumes', 0)
      })
      this.form.id = ''
    },
    submitModalNew () {
      this.$store.dispatch('volumes/createVolume', this.form).then(() => {
        this.$store.dispatch('volumes/getVolumes', 0)
      })
    },
    getAttachedServerNameFromVolume (id) {
      var data = this.$store.getters['computes/getComputeByID'](id)
      if (data) {
        return data.name
      } else {
        return this.locale.volumes.notInUse
      }
    },
    attachVolumeToServer: function (ComputeId, volumeId) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('computes/attachVolume', {
            'volume_id': volumeId,
            'ComputeId': ComputeId
          }).then((response) => {
            this.$store.dispatch('volumes/getVolumes', 0)
            this.form.id = ''
            this.form.selectedCompute = ''
          }).catch((error) => {
            console.log(error)
          })
          this.closeModal({id: 'modalAttach'})
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    detachVolumeFromServer: function (ComputeId, volumeId) {
      this.$store.dispatch('computes/detachVolume', {'volume_id': volumeId, 'ComputeId': ComputeId}).then((response) => {
        this.$store.dispatch('volumes/getVolumes', 0)
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  created () {
    this.$store.dispatch('volumes/getVolumes', 1)
    this.refresh()
  },
  destroyed () {
    clearInterval(this.interval)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Volume.vue